const MiddleSection = () => {
  return (
    <div className="box-middle">
      <div className="box-middle_img1">
      </div>
      <div className="box-middle_img2">
        <img className="fondo-medio-back" width="100%" height="100px" alt=""></img>
      </div>
      <div className="box-middle_text">
        <div className="box-middle_text1">
          <p>
            Nacimos en el Mar. Crecimos en el bosque.
          </p>
        </div>
        <div className="box-middle_text2">
          <p>
            Más de 20 años haciendo chocolate artesanal de calidad
          </p>
        </div>
      </div>
    </div>
  );
};

export default MiddleSection;